import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || "https://api.systemicsurvey.com";

// Crear instancia de axios con configuración base
const axiosInstance = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Flag para evitar múltiples llamadas simultáneas de refresh token
let isRefreshing = false;
let failedQueue = [];

const redirectToLoginIfNeeded = () => {
  if (typeof window === 'undefined') return;
  const pathname = window.location.pathname;
  // /encuesta es pública: los empleados acceden con token en la URL, no deben redirigir al login
  if (pathname !== '/login' && !pathname.startsWith('/encuesta')) {
    window.location.href = '/login';
  }
};

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

// Interceptor de respuesta para manejar 401 y refresh token automáticamente
axiosInstance.interceptors.response.use(
  (response) => {
    // Si la respuesta es exitosa, simplemente la devolvemos
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    const status = error.response?.status;
    const isAuthError = status === 401 || status === 403;

    // Si el error es de autenticación y no es una petición de login o refresh-token
    if (isAuthError &&
      !originalRequest._retry &&
      !originalRequest.url?.endsWith('/auth/login') &&
      !originalRequest.url?.endsWith('/auth/refresh-token')) {

      // Si ya hay un refresh en proceso, encolar esta petición
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers['Authorization'] = 'Bearer ' + token;
            return axiosInstance(originalRequest);
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshResponse = await axios.post(`${apiUrl}/auth/refresh-token`, {}, {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
          },
        });

        processQueue(null, null);

        // Reintentar la petición original
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);

        // Si el refresh token falla, redirigir al login
        if (refreshError.response?.status === 401 || !refreshError.response) {
          redirectToLoginIfNeeded();
        }

        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    // Para otros errores, simplemente los rechazamos
    return Promise.reject(error);
  }
);


export default axiosInstance;
